function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.48 22.926l-1.193.658C7.308 27.205-4.795 6.09 2.008 2.1l1.145-.637L6.867 7.93l-1.139.632c-2.067 1.245 2.76 9.707 4.879 8.545l1.162-.642 3.711 6.461zM5.672 0l-1.68.975 3.714 6.466 1.681-.975L5.672 0zm8.613 14.997l-1.68.975 3.714 6.467L18 21.464l-3.715-6.467z",
  fill: "#000"
});

function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxOCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjQ4IDIyLjkyNkwxNC4yODcgMjMuNTg0QzcuMzA3OTggMjcuMjA1IC00Ljc5NTAyIDYuMDkgMi4wMDc5OCAyLjFMMy4xNTI5OCAxLjQ2M0w2Ljg2Njk4IDcuOTNMNS43Mjc5OCA4LjU2MkMzLjY2MDk4IDkuODA3IDguNDg3OTggMTguMjY5IDEwLjYwNyAxNy4xMDdMMTEuNzY5IDE2LjQ2NUwxNS40OCAyMi45MjZaTTUuNjcxOTggMEwzLjk5MTk4IDAuOTc1TDcuNzA1OTggNy40NDFMOS4zODY5OCA2LjQ2Nkw1LjY3MTk4IDBaTTE0LjI4NSAxNC45OTdMMTIuNjA1IDE1Ljk3MkwxNi4zMTkgMjIuNDM5TDE4IDIxLjQ2NEwxNC4yODUgMTQuOTk3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { SvgPhoneIcon as ReactComponent };